/*
 * @Description: 行业资讯骨架屏
 * @Author: liuzhezhe
 * @Date: 2023-08-04 11:27:47
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-08-04 14:56:01
 */
import React, { useState, useEffect } from 'react'
import styles from './index.scss'

const VideoSkeletons = (props) => {
  const [state] = useState([1, 2, 3, 4, 5, 6])

  useEffect(() => {

  }, [])

  return (
    <div className={styles['order-skeletons']}>
      <div className={styles['iframe-left']}>
        <div className={styles['skeletons']}></div>
        <div className={styles['skeletons']}></div>
        <div className={styles['skeletons']}></div>
      </div>
      <div className={styles['iframe-right']}>
        <div className={styles['xgtj']}></div>
        {state.map(item => (
          <div className={styles['order-item']} key={item}>
            <div className={styles['skeletons']}></div>
            <div className={styles['content']}>
              <div></div>
              <div></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default VideoSkeletons
